import { DetailPageElement } from "./Page.styles";

/**
 * DetailPage
 *
 * Provides the outer page wrapper for any detail screen, rendering its children
 * inside `DetailPageElement`.
 *
 * Props
 * - children (React.ReactNode): elements to display within the page container
 */

const DetailPage = ({ children }) => {
  return <DetailPageElement>{children}</DetailPageElement>;
};

export { DetailPage };
